<template>
<v-container fluid grid-list-md style="padding: 30px;">
  <v-row>
    <v-col cols="12" sm="12" md="6">
      <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id" label="Selecione o Evento" @input="carregaInscritos()" color="#0D47A1"></v-select>
    </v-col>
  </v-row>
  <v-data-table :search="search" v-if="!addUser" :headers="headers" :items="inscritos" sort-by="nome" class="elevation-1" style="border-radius: 10px;">
    <template v-slot:top>
      <v-toolbar flat color="white" style="border-radius: 10px;">
        <v-toolbar-title class="textoUser">INSCRITOS
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon @click="editItem(item)" v-if="user.tipo != 'CHECKIN'">
        edit
      </v-icon>
      <v-icon @click="sendEmail(item)" v-if="user.tipo != 'CHECKIN'">
        send
      </v-icon>
      <v-icon @click="openDialog(item)">
        check_circle
      </v-icon>
      <v-icon @click="deleteItem(item)" v-if="user.tipo != 'CHECKIN'">
        delete
      </v-icon>
      <v-icon v-if="eventoId == '61ec94340cf286040f6c78ad' || eventoId == '61ec9a360cf286040f6c78ae'" @click="printItem(item)">
        print
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-card-actions>
        <v-btn color="#7B1FA2" @click="carregaDados" style="color: #ffffff">Recarregar</v-btn>
      </v-card-actions>
    </template>
  </v-data-table>
  <br>
  <v-btn color="#7B1FA2" @click="print" style="color: #ffffff">Imprimir</v-btn>
  <v-dialog v-model="dialog" max-width="350px">
    <v-card style="border-radius: 10px;">
      <v-card-title style="justify-content: center; padding: 8px;">
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="6" md="12" style="padding: 2px;">
              <p class="texto" style="color:#8E24AA">Realizar checkin manual</p>
            </v-col>
            <v-col cols="12" sm="6" md="12" style="padding: 2px;">
              <p class="texto">Nome: {{nome}}</p>
            </v-col>
            <v-col cols="12" sm="6" md="12" style="padding: 2px;">
              <p class="texto">Código: {{checkin.cod_incricao}}</p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions style="margin-top: -32px;padding: 20px 5px 0px;">
        <v-container fluid grid-list-md>
          <v-layout row wrap justify-center>
            <v-flex xs6 sm6 lg6>
              <v-btn :loading="loading" dark depressed block color="#4A148C" style="border-radius: 7px;" large @click="realizaCheckin">Validar</v-btn>
            </v-flex>
            <v-flex xs6 sm6 lg6>
              <v-btn dark depressed block color="#D32F2F" style="border-radius: 7px;" large @click="close">Fechar</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="editarInscricao" max-width="1000px">
    <v-card style="border-radius: 10px;">
      <v-card-title>
        <span class="textoUser">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <p style="margin-bottom: 5px">Informações da inscrição</p>
              <v-divider />
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="8">
              <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#7B1FA2" dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field v-model="editedItem.cpf" outlined label="CPF" color="#7B1FA2" dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field v-model="editedItem.email" outlined label="E-mail" color="#7B1FA2" dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field v-model="editedItem.telefone" outlined label="Telefone" color="#7B1FA2" dense v-mask="'(##) #####-####'" hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-select v-model="editedItem.sexo" outlined label="Sexo" color="#7B1FA2" :items="sexos" hide-details item-text="text" item-value="value" dense></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4" v-if="editedItem.cargo">
              <v-text-field v-model="editedItem.cargo" outlined label="E-mail" color="#7B1FA2" dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4" v-if="editedItem.empresa">
              <v-text-field v-model="editedItem.empresa" outlined label="Empresa" color="#7B1FA2" dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4" v-if="editedItem.nomeCracha">
              <v-text-field v-model="editedItem.nomeCracha" outlined label="Nome Crachá" color="#7B1FA2" dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4" v-if="editedItem.tipo">
              <v-select v-model="editedItem.tipo" outlined label="Tipo de Inscrição" color="#7B1FA2" :items="tipos" hide-details item-text="text" item-value="value" dense></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field v-model="editedItem.infoVacina" outlined label="Informação Vacinal" color="#7B1FA2" dense disabled hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field v-model="editedItem.numero" outlined label="Nº Identificação" color="#7B1FA2" dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-select v-model="editedItem.participantes" outlined label="Quantidade" color="#7B1FA2" :items="quantidade" hide-details item-text="text" item-value="value" dense></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" v-if="editedItem.statusPagamento || editedItem.formOfPayment || editedItem.valorPago || editedItem.codigoTransacao">
              <p style="margin-bottom: 5px">Informações do pagamento</p>
              <v-divider />
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3">
              <v-select v-model="editedItem.statusPagamento" outlined label="Status de Pagamento" color="#7B1FA2" :items="statusPagamento" hide-details item-text="text" item-value="value" dense></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.formOfPayment != ''">
              <v-select v-model="editedItem.formOfPayment" outlined label="Forma de Pagamento" color="#7B1FA2" :items="formaPagamento" hide-details item-text="text" item-value="value" dense></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3">
              <v-text-field v-model="editedItem.valorPago" prefix="R$" outlined label="Valor Pago" color="#7B1FA2" dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.codigoTransacao != ''">
              <v-text-field v-model="editedItem.codigoTransacao" outlined label="Código de Transação" color="#7B1FA2" dense disabled hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" v-if="arquivoComprovanteVacinal != ''">
              <v-card elevation="6">
                <v-img v-if="arquivoComprovanteVacinal != ''" :src="arquivoComprovanteVacinal" height="130px"></v-img>
                <v-alert v-if="arquivoComprovanteVacinal == ''" dark dense text outlined :value="true" color="warning" icon="info" prominent>Nenhum anexo enviado</v-alert>
                <v-card-title style="font-size: 17px">COMPROVANTE VACINAL</v-card-title>
                <v-card-actions>
                  <v-btn v-if="arquivoComprovanteReciclagem != ''" color="#7B1FA2" @click="visualizaImagem(arquivoComprovanteVacinal)" text>Visualizar</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#4A148C" class="cssBotao" dark large @click="save">Salvar</v-btn>
        <v-btn color="#BA68C8" class="cssBotao" large dark @click="close">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-container grid-list-md v-show="false">
    <v-layout row wrap id="printInscricao" style="padding: 15px">
      <v-flex xs12 sm12 lg12>
        <img src="../assets/liberdade.png" width="180px">
      </v-flex>
      <v-flex xs12 sm12 lg12>
        <br>
        <p style="font-size: 18px; text-align: center"><b>CADASTRO DO PARTICIPANTE - ED2022 4, 5 e 6 MARÇO 2022</b></p>
        <br>
      </v-flex>
      <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>NOME</b></p>
        <p style="padding-left: 3px">{{impressao.nome}}</p>
      </v-flex>
      <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>CPF</b></p>
        <p style="padding-left: 3px">{{impressao.cpf}}</p>
      </v-flex>
      <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>IDENTIFICAÇÃO</b></p>
        <p style="padding-left: 3px">{{impressao.numero}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>DATA DE NASCIMENTO</b></p>
        <p style="padding-left: 3px">{{impressao.dataNascimento}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>SEXO</b></p>
        <p style="padding-left: 3px">{{impressao.sexo}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>TELEFONE</b></p>
        <p style="padding-left: 3px">{{impressao.telefone}}</p>
      </v-flex>
      <v-flex xs5 sm5 lg5 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>PREFERE SER CHAMADO(A) POR</b></p>
        <p style="padding-left: 3px">{{impressao.nomeSocial}}</p>
      </v-flex>
      <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>TIPO DE INSCRIÇÃO</b></p>
        <p style="padding-left: 3px">{{impressao.tipo}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>TAMANHO DA CAMISA</b></p>
        <p style="padding-left: 3px">{{impressao.tamanhoCamisa}}</p>
      </v-flex>
      <v-flex xs12 sm12 lg12 style="margin-top: 10px">
        <p>Informações da célula</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>CÉLULA</b></p>
        <p style="padding-left: 3px">{{impressao.celula}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>LÍDER DA CÉLULA</b></p>
        <p style="padding-left: 3px">{{impressao.nomeLider}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>TELEFONE DO LÍDER</b></p>
        <p style="padding-left: 3px">{{impressao.telefoneLider}}</p>
      </v-flex>
      <v-flex xs12 sm12 lg12 style="margin-top: 10px">
        <p>Informações de contato dos pais</p>
      </v-flex>
      <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>NOME DA MÃE</b></p>
        <p style="padding-left: 3px">{{impressao.nomeMae}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>TELEFONE</b></p>
        <p style="padding-left: 3px">{{impressao.telefoneMae}}</p>
      </v-flex>
      <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>NOME DO PAI</b></p>
        <p style="padding-left: 3px">{{impressao.nomePai}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>TELEFONE</b></p>
        <p style="padding-left: 3px">{{impressao.telefonePai}}</p>
      </v-flex>
      <v-flex xs12 sm12 lg12 style="margin-top: 10px">
        <p>Informações dos três amigos</p>
      </v-flex>
      <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>NOME AMIGO(A) 1</b></p>
        <p style="padding-left: 3px">{{impressao.nomeAmigo1}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>TELEFONE</b></p>
        <p style="padding-left: 3px">{{impressao.telefoneAmigo1}}</p>
      </v-flex>
      <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>NOME AMIGO(A) 2</b></p>
        <p style="padding-left: 3px">{{impressao.nomeAmigo2}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>TELEFONE</b></p>
        <p style="padding-left: 3px">{{impressao.telefoneAmigo2}}</p>
      </v-flex>
      <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>NOME AMIGO(A) 3</b></p>
        <p style="padding-left: 3px">{{impressao.nomeAmigo3}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>TELEFONE</b></p>
        <p style="padding-left: 3px">{{impressao.telefoneAmigo3}}</p>
      </v-flex>
      <v-flex xs12 sm12 lg12>
        <br>
      </v-flex>
      <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>USA MEDICAMENTO CONTÍNUO?</b></p>
        <p style="padding-left: 3px" v-if="impressao.usaMedicamento == true">SIM</p>
        <p style="padding-left: 3px" v-else>NÃO</p>
      </v-flex>
      <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>MEDICAMENTO UTILIZADO</b></p>
        <p style="padding-left: 3px">{{impressao.medicamento}}</p>
      </v-flex>
      <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>ALÉRGICO A ALGUMA MEDICAÇÃO</b></p>
        <p style="padding-left: 3px" v-if="impressao.possuiAlergia == true">SIM</p>
        <p style="padding-left: 3px" v-else>NÃO</p>
      </v-flex>
      <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>ALERGIA</b></p>
        <p style="padding-left: 3px">{{impressao.alergia}}</p>
      </v-flex>
      <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>POSSUI RESTRIÇÃO ALIMENTAR</b></p>
        <p style="padding-left: 3px" v-if="impressao.restricaoAlimentar == true">SIM</p>
        <p style="padding-left: 3px" v-else>NÃO</p>
      </v-flex>
      <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>RESTRIÇÃO</b></p>
        <p style="padding-left: 3px">{{impressao.restricoes}}</p>
      </v-flex>
      <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>NECESSITA ATENDIMENTO ESPECIAL</b></p>
        <p style="padding-left: 3px" v-if="impressao.atendimentoEspecial == true">SIM</p>
        <p style="padding-left: 3px" v-else>NÃO</p>
      </v-flex>
      <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>NECESSIDADE</b></p>
        <p style="padding-left: 3px">{{impressao.necessidades}}</p>
      </v-flex>
      <v-flex xs12 sm12 lg12 style="text-align: center">
        <br>
        <img src="../assets/logoAIPassIntelite-preto.png" width="230px">
      </v-flex>
    </v-layout>

    <v-layout row wrap id="printEquipe" style="padding: 15px">
      <v-flex xs12 sm12 lg12>
        <img src="../assets/liberdade.png" width="180px">
      </v-flex>
      <v-flex xs12 sm12 lg12>
        <br>
        <p style="font-size: 18px; text-align: center"><b>CADASTRO EQUIPE - ED2022 4, 5 e 6 MARÇO 2022</b></p>
        <br>
      </v-flex>
      <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>NOME</b></p>
        <p style="padding-left: 3px">{{impressao.nome}}</p>
      </v-flex>
      <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>CPF</b></p>
        <p style="padding-left: 3px">{{impressao.cpf}}</p>
      </v-flex>
      <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>IDENTIFICAÇÃO</b></p>
        <p style="padding-left: 3px">{{impressao.numero}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>DATA DE NASCIMENTO</b></p>
        <p style="padding-left: 3px">{{impressao.dataNascimento}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>SEXO</b></p>
        <p style="padding-left: 3px">{{impressao.sexo}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>TELEFONE</b></p>
        <p style="padding-left: 3px">{{impressao.telefone}}</p>
      </v-flex>
      <v-flex xs12 sm12 lg12 style="margin-top: 10px">
        <p>Informações da célula e contato do líder ou contato do supervisor da célula</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>CÉLULA</b></p>
        <p style="padding-left: 3px">{{impressao.celula}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>LÍDER DA CÉLULA</b></p>
        <p style="padding-left: 3px">{{impressao.nomeLider}}</p>
      </v-flex>
      <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>TELEFONE DO LÍDER</b></p>
        <p style="padding-left: 3px">{{impressao.telefoneLider}}</p>
      </v-flex>
      <v-flex xs12 sm12 lg12 style="margin-top: 10px">
        <br>
      </v-flex>
      <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>FEZ ENCONTRO COM DEUS NA LIBERDADE?</b></p>
        <p style="padding-left: 3px" v-if="impressao.realizouEncontro == true">SIM</p>
        <p style="padding-left: 3px" v-else>NÃO</p>
      </v-flex>
      <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>POSSUI ALERGIA A AR CONDICIONADO</b></p>
        <p style="padding-left: 3px" v-if="impressao.alergiaAr == true">SIM</p>
        <p style="padding-left: 3px" v-else>NÃO</p>
      </v-flex>
      <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
        <p style="padding-left: 3px"><b>NOME PARA O CRACHÁ</b></p>
        <p style="padding-left: 3px">{{impressao.crachaNome}}</p>
      </v-flex>
      <v-flex xs12 sm12 lg12 style="text-align: center">
        <br>
        <img src="../assets/logoAIPassIntelite-preto.png" width="230px">
      </v-flex>
    </v-layout>
  </v-container>

  <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
  <Snackbar ref=chamaSnackbar />
  <div v-show="true">
    <Inscricoes ref="inscricoes"></Inscricoes>
  </div>
</v-container>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import {
  baseApiUrl
} from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import Inscricoes from '../componentes/inscricoes.vue'
import moment from 'moment'
import axios from 'axios'
import PH from 'print-html-element'
import {
  mapState
} from 'vuex'
export default {
  components: {
    Snackbar,
    Loading,
    Inscricoes,
  },
  data: () => ({
    editarInscricao: false,
    eventoId: '',
    eventoIdAtual: '',
    fullPage: true,
    isLoading: false,
    loading: false,
    search: '',
    nome: '',
    addUser: false,
    dialog: false,
    checkin: {
      cod_incricao: '',
      tipo: '',
      eventoId: '',
      userValidatorId: '',
    },
    quantidade: [],
    statusPagamento: ['CANCELADO','ESTORNADO','PAGO','PENDENTE'],
    sexos: ['MASCULINO','FEMININO'],
    tipos: ['MEMBRO','VISITANTE'],
    formaPagamento: [
      { value: 'BOLETO', text: 'BOLETO'},
      { value: 'CARTAO', text: 'CARTÃO'},
      { value: 'EM MAOS', text: 'EM MÃOS'},
      { value: 'PIX', text: 'PIX'},
    ],
    headers: [
      { text: 'Código', value: 'cod_incricao' },
      { text: 'Nome', align: 'start', value: 'nome', },
      { text: 'CPF', value: 'cpf' },
      { text: 'Telefone', value: 'telefone' },
      { text: 'Sexo', value: 'sexo' },
      { text: 'Quantidade', value: 'participantes' },
      { text: 'Forma de Pagamento', value: 'formOfPayment' },
      { text: 'Lote', value: 'lote' },
      { text: 'Valor', value: 'valorPago' },
      { text: 'Data Pagamento', value: 'dataHoraPagamento' },
      { text: 'Parcelas', value: 'parcelas'},
      { text: 'Status', value: 'statusPagamento' },      
      { text: 'Realizada em', value: 'dataHora' },
      { text: 'Checkin', value: 'checkin' },
      { text: 'Validador', value: 'validador' },
      { text: 'Código Transação', value: 'codigoTransacao' },
      { text: 'Ações', value: 'action', align: 'center', sortable: true },
    ],
    editedIndex: -1,
    editedItem: {
      nome: "",
      cpf: "",
      email: "",
      id: "",
      statusPagamento: "",
      sexo: "",
      telefone: "",
      cargo: "",
      empresa: "",
      nomeCracha: "",
      tipo: "",
      celula: "",
      infoVacina: '',
      formOfPayment: '',
      valorPago: '',
      codigoTransacao: '',
      numero: '',
      participantes: '',
    },
    arquivoComprovanteVacinal: "",
    eventos: [],
    inscritos: [],
    impressao: []
  }),

  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    user: state => state.userObj,
    companyobj: state => state.companyObj,
    formTitle() {
      return this.editedIndex === -1 ? 'ADICIONAR INSCRIÇÃO' : 'EDITAR INSCRIÇÃO'
    }
  }),

  mounted() {
    this.carregaDados()
  },

  methods: {
    async printItem(item) {
      this.isLoading = true
      try {
        await axios.get(`${baseApiUrl}inscricoes/${item.id}`).then(response => {
          if (response.data) {
            this.impressao = Object.assign({}, response.data)
            setTimeout(() => {
              if (this.eventoId == '61ec94340cf286040f6c78ad') {
                PH.printElement(document.getElementById('printInscricao'))
              } else if (this.eventoId == '61ec9a360cf286040f6c78ae') {
                PH.printElement(document.getElementById('printEquipe'))
              }
              this.isLoading = false
            }, 50);
          }
        })
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao imprimir. Tente novamente", "DESCULPE")
      }
    },

    async carregaDados() {
      this.isLoading = true
      await axios.get(`${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"${this.companyobj.id}"}]}}`)
        .then(res => {
          if (res.data != '') {
            for (var key in res.data) {
              if (res.data.hasOwnProperty(key)) {
                this.eventos.push(res.data[key])
              }
            }
            this.eventos = this.eventos.sort(this.compare)
            this.eventoId = this.eventos[0].id
            if (this.eventoIdAtual != '')
              this.eventoId = this.eventoIdAtual
          } else
            this.isLoading = false
        })
        this.quantidade = []
        for (let i = 0; i < 51; i++) {
          if (i > 0) {
            this.quantidade.push(i)
          }
        }
      await this.carregaInscritos()
    },

    preparaImpressao() {
      var pr = this;
      pr.$refs.inscricoes.preparaImpressao()
    },

    print() {
      var vm = this;
      vm.$refs.inscricoes.print();
    },

    async save() {
      this.isLoading = true
      if (this.editedIndex != -1) {
        this.editedItem.nome = this.editedItem.nome
        this.editedItem.cpf = this.editedItem.cpf
        this.editedItem.email = this.editedItem.email.trim()
        this.editedItem.statusPagamento = this.editedItem.statusPagamento
        await axios.patch(`${baseApiUrl}inscricoes/${this.editedItem.id}`, this.editedItem)
        .then(res => {
          if (res.data != null) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaDados()
          }
        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
        })
      } else {
        this.editedItem.empresaId = this.companyobj.id
        await axios.post(`${baseApiUrl}Eventos/replaceOrCreate`, this.editedItem).then(res => {
          this.id_evento = res.data.id
          if (res.data != null) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Evento cadastrado com sucesso!", "INFORMAÇÃO")
            this.carregaDados()
          }
        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao cadastrar evento, tente novamente", "ERRO")
        })
      }
      this.close()
    },

    compare(a) {
      // Use toUpperCase() to ignore character casing
      const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
      //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
      const dataC = moment().format()

      let comparison = 0;
      if (dataC >= dataA)
        comparison = 1;
      /*             else
                  if (dataA >= dataC && dataB < dataA)
                      comparison = -1; */
      else
      if (dataC < dataA)
        comparison = -1;
      return comparison;

    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHour(data_hora) {
      let data = data_hora.substr(0, 10).split('-')
      data = data[2] + '/' + data[1] + '/' + data[0]
      let hora = data_hora.substr(11, 8)

      return data + ' ' + hora

    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    async carregaInscritos() {
      await axios.get(`${baseApiUrl}Inscricoes?filter[include]=userValidatorCheckin&filter[where][eventoId]=${this.eventoId}`)
        .then(res => {
          this.inscritos = []
          sessionStorage.setItem('Inscritos',JSON.stringify(res.data))
          for (var key in res.data) {            
            if (res.data.hasOwnProperty(key)) {
              this.inscritos.push({
                'nome': res.data[key].nome,
                'cod_incricao': res.data[key].cod_incricao,
                'telefone': res.data[key].telefone,
                'cpf': res.data[key].cpf,
                'sexo': res.data[key].sexo,
                'codigoTransacao': res.data[key].codigoTransacao,
                'dataHora': moment(res.data[key].created).format("DD/MM/YYYY HH:mm:ss"),
                'checkin': res.data[key].checkin == null ? '' : this.formatDate(res.data[key].checkin.substr(0, 10)) + " " + res.data[key].checkin.substr(11, 8),
                'id': res.data[key].id,
                'formOfPayment': res.data[key].formOfPayment,
                'statusPagamento': res.data[key].statusPagamento,
                'valorPago': res.data[key].valorPago,
                'numero': res.data[key].numero,
                'participantes': this.exibeParticipantes(res.data[key].participantes),
                'parcelas': res.data[key].parcelas,
                'lote': res.data[key].lote,
                'dataHoraPagamento': this.formatDateHora(res.data[key].dataHoraPagamento),
                'validador': res.data[key].userValidatorCheckin == undefined ? '' : res.data[key].userValidatorCheckin.nome
              });
            }
          }
          this.isLoading = false
          this.preparaImpressao()
        })
    },

    exibeParticipantes(numero) {
      if (!numero) {
        return 1
      } else {
        return numero
      }
    },

    async realizaCheckin() {
      this.loading = true
      await axios.post(`${baseApiUrl}inscricoes/checkin`, this.checkin)
        .then(res => {
          if (res.data != '') {
            switch (res.data.codigo) {
              case 3:
                //'Checkin confirmado
                this.loading = false
                this.close()
                var vm = this
                vm.$refs.chamaSnackbar.snack("#0288D1", "Checkin realizada com sucesso!", "INFORMAÇÃO")
                break;
              case 1:
                //'Checkin ja realizado'
                this.close()
                vm = this
                vm.$refs.chamaSnackbar.snack("#0288D1", "Checkin já realizado!", "INFORMAÇÃO")
                this.loading = false
                break;
              default:
                break;
            }
          } else {
            vm = this
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
        })
      await this.carregaInscritos()

    },

    openDialog(item) {
      this.checkin.cod_incricao = item.cod_incricao
      this.checkin.tipo = 'CHECKIN'
      this.checkin.eventoId = this.eventoId
      this.checkin.userValidatorId = this.user.id
      this.nome = item.nome
      this.dialog = true
    },

    async editItem(item) {
      this.isLoading = true
      this.editedIndex = this.inscritos.indexOf(item)
      try {
        await axios.get(`${baseApiUrl}inscricoes/${item.id}`).then(response => {
          if (response.data) {
            this.pegaImagem(response.data.id)
            this.editedItem.nome = response.data.nome
            this.editedItem.cpf = response.data.cpf
            this.editedItem.email = response.data.email
            this.editedItem.statusPagamento = response.data.statusPagamento
            this.editedItem.id = response.data.id
            this.editedItem.telefone = response.data.telefone
            this.editedItem.cargo = response.data.cargo
            this.editedItem.empresa = response.data.empresa
            this.editedItem.nomeCracha = response.data.nomeCracha
            this.editedItem.tipo = response.data.tipo
            this.editedItem.sexo = response.data.sexo
            this.editedItem.celula = response.data.celula
            this.editedItem.infoVacina = this.exibeInformacaoVacina(response.data.infoVacina)
            this.editedItem.formOfPayment = response.data.formOfPayment
            this.editedItem.valorPago = response.data.valorPago
            this.editedItem.codigoTransacao = response.data.codigoTransacao
            this.editedItem.numero = response.data.numero
            this.editedItem.participantes = response.data.participantes
            this.editarInscricao = true
            this.isLoading = false
          }
        })
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Problema encontrado ao editar inscrição", "DESCULPE")
      }
    },

    async pegaImagem(idInscricao) {
      await axios.get(`${baseApiUrl}ImagesDocs?filter={"where":{"inscricaoId":"${idInscricao}"}}`)
      .then(response => {
        if (response.data.length != 0) {
          this.editedItem.arquivoComprovanteVacinal = response.data[0].arquivoComprovanteVacinal
        }
      })
    },

    exibeInformacaoVacina(informacao) {
      if (informacao == '1Dose') return 'TOMOU A 1ª DOSE'
      if (informacao == '2Dose') return 'TOMOU A 2ª DOSE'
      if (informacao == '3Dose') return 'TOMOU A 3ª DOSE'
      if (informacao == '0Dose') return 'NÃO VACINADO'
      if (informacao == 'naoInformado') return 'NÃO INFORMOU'
    },

    async sendEmail(item) {
      this.isLoading = true
      this.editedItem.id = item.id
      try {
        await axios.post(`${baseApiUrl}Inscricoes/EmailRecuperaAcesso`, {"inscricaoId": this.editedItem.id} ).then(res => {
          if (res.data) {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "E-mail enviado com sucesso!", "SUCESSO")
          }
        })
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao enviar e-mail, tente novamente", "DESCULPE")
      }
    },

    async deleteItem(item) {
      var r = confirm('Deseja realmente excluir: ' + item.nome + ' do Evento?')
      if (r == true) {
        this.isLoading = true
        await axios.delete(`${baseApiUrl}Inscricoes/${item.id}`)
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.eventoIdAtual = this.eventoId
            this.carregaDados()
            //this.eventoId = this.eventoIdAtual
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
      }
    },

    close() {
      this.dialog = false
      this.editarInscricao = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
  },
}
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 150px;
  font-size: 7px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>
